import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';

import { configuration } from './../../configuration';
import { AuthService } from '@pluritech/auth-service';
@Component({
  selector: 'app-dash',
  templateUrl: './dash.component.html',
  styleUrls: ['./dash.component.scss']
})
export class DashComponent implements OnInit, OnDestroy {

  public projectName: any = configuration.projectName;
  public userDefault: string = configuration.userDefaultImage;
  public logoDefault: string = configuration.logoDefaultImage;
  public logosmall: string = configuration.logosmallImage;
  
  private classes: string[] = [configuration.skin, 'sidebar-mini'];
  profileimage_path:String;
  first_name:String;
  last_name:any



  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  public async logout(): Promise<void> {
    localStorage.clear();
    this.router.navigate(['/login']);
  /*
    try {
      await this.authService.logout();
      this.router.navigate(['/login']);
  localStorage.clear();
  
    } catch (e) {
      console.log('err logout', e);
    }
  */
  
  
  }

  ngOnInit() {

    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    
    this.profileimage_path=atob(currentUser.profileimage_path);
    
    this.first_name=atob(currentUser.first_name);
    this.last_name=atob(currentUser.last_name);

console.log("currentUser.profile_pic",atob(currentUser.profile_pic))

console.log("currentUser.profile_pic",atob(currentUser.profileimage_path))

    
    //first_name


    $(document).ready(() => {

//console.log("menu loading")

	const layout = $('body').data('lte.layout');
      if (layout) {
        layout.fix();
      }
      const trees: any = $('[data-widget="tree"]');
      if (trees) {
        trees.tree();
      }
    });
    const body = document.getElementsByTagName('body')[0];
    for (const cl of this.classes) {
      body.classList.add(cl);
    }
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    for (const cl of this.classes) {
      body.classList.remove(cl);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/parts/dash/dash.component.ts